import { Component, OnInit, inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '../../components/button/button.component';
import { User } from '@sentry/angular';
import { SharedModule } from '@app/shared/shared.module';
import { UserRepository } from '@app/shared/state/user/user.repository';

@Component({
  selector: 'buy-success-modal',
  templateUrl: './buy-success-modal.component.html',
  styleUrls: ['./buy-success-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class BuySuccessModalComponent implements OnInit {
  dialog = inject(MatDialog);
  private eventManager = inject(EventManager);
  private userRepo = inject(UserRepository);
  buySuccessModalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  purchasedCoins: boolean;

  get user(): User {
    return this.userRepo.getUser();
  }

  ngOnInit(): void {
    this.purchasedCoins = this.buySuccessModalData.reward.credits !== 0;
  }

  public redeem() {
    this.userRepo.updateUser({
      buys: this.user.buys + 1,
    });
    this.eventManager.closeModal(new Modal(this.buySuccessModalData.id, ModalType.Persisted, this.buySuccessModalData));
  }
}
